import { RevenueDeepDiveModal } from 'modules';



export const RevenueDeepDiveActivity = () => {
  return (
    <RevenueDeepDiveModal.FC />
  );
};
